<template>
  <div class="look">

    <div class="viewbox">

      <div class="viewinfo">

        <div class="view">
         <video
            id="myVideo"
            class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid"
            style="height: 100%;"
          >
          </video>

        </div>

        <div class="lesson_list" v-if="myCourseLessonList">
          <div class='item' v-for="sub in myCourseLessonList.lesson" :key="sub.id">
           
            <div class="tit_name">
              <!-- <span class="f1">{{myCourseLessonList.course.course_name}}</span>
              <span class="f2">{{sub.lesson_name}}</span> -->
              <span class="f1">{{sub.lesson_name}}</span>
              <span class="f2">{{sub.lesson_short_desc}}</span>
            </div>
             <div class="tit_info">
               <div class="imgbox"  @click="onLook(sub.course_id, sub.id)">
                 <img :src="sub.lesson_image" alt="" >
                
               </div>
               <div class="info">
                <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="v_name" v-if="courseLessonDetail">
        {{courseLessonDetail.lesson_name}}
      </div>

    </div>

    <div class="course_desc" v-if="courseLessonDetail">
      <div class="desc">
       <div class="tit">课程简介</div>
       <div class="con">{{courseLessonDetail.lesson_desc}}</div>
      </div>

      <div class="goindex">
        <img :src="myCourseLessonList.sidebar_banner.banner_image" alt="">
        <el-button type="primary" @click="onGoHome">报名课程</el-button>
      </div>

    </div>

    <div class="free" v-if="myCourseLessonList">

      <div class="free_course_box">
        <div class="tit">
          <span class="t1">免费试听课程</span>
          <span class="t2">FREE AUDITION</span>
        </div>

        <el-carousel height="210px" :autoplay="false" :loop="false" >
          <el-carousel-item v-for="(item, index) in myCourseLessonList.f_free_course_lesson_list" :key="index">
            <div class='item' v-for="sub in item" :key="sub.id">
            
              <div class="tit_name">
                <span class="f1">{{sub.course_name}}</span>
                <span class="f2">{{sub.lesson_short_desc}}</span>
              </div>
              <div class="tit_info">
                <div class="imgbox"  @click="onLook(sub.course_id)">
                  <img :src="sub.lesson_image" alt="" >
                   <div class="playBtn">
                    <a href="#" title="start">start</a>
                  </div>
                </div>
                <div class="info">
                  <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                  <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                  <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>

      <div class="banner_box">
        <div class="box">
          <a v-for="item in myCourseLessonList.index_bottom_banner" :key="item.id" :href="item.banner_url" target="_blank">
            <img :src="item.banner_image" alt="" >
          </a>
        </div>
      </div>

    </div>


  </div>
</template>

<script>

export default {
  name: 'look',
  data:function () {
    return {
      myCourseLessonList:null,
      courseLessonDetail:null,
      myVideo:null,
      timer:null,
    }
  },
  
  created(){
    console.log("Look created")
    this.fetch();
  },
  mounted() { 
    this.initVideo();
  },
  methods:{
   async fetch(){

     let obj = this.$route.params.id ? {course_id:this.$route.params.id} : null;
     let data = await this.$fly.get('/course/courseDetail',obj);

     //组合免费课
    data.f_free_course_lesson_list = [];
    for (let i = 0; i < data.free_course_lesson_list.length; i++) {
      let f = parseInt(i/3);
      
      if (data.f_free_course_lesson_list[f]){
       data.f_free_course_lesson_list[f].push(data.free_course_lesson_list[i]);
      }else{
         data.f_free_course_lesson_list[f] = [];
         data.f_free_course_lesson_list[f].push(data.free_course_lesson_list[i]);
      }
    }

     this.myCourseLessonList = data;
     console.log("myCourseLessonList:",this.myCourseLessonList);

    
    if (this.$route.params.course_lesson_id){
      let courseLessonDetail = await this.$fly.get('/course/courseLessonDetail',{course_lesson_id:this.$route.params.course_lesson_id});
      this.courseLessonDetail = courseLessonDetail;
    }else{
      let play_lesson_id = this.myCourseLessonList.last_course_lesson_id == 0 ? this.myCourseLessonList.lesson[0].id : this.myCourseLessonList.last_course_lesson_id;
      let courseLessonDetail = await this.$fly.get('/course/courseLessonDetail',{course_lesson_id:play_lesson_id});
      this.courseLessonDetail = courseLessonDetail;
    }
     console.log("courseLessonDetail:",this.courseLessonDetail);

     if (this.courseLessonDetail.code === 500103){
        this.$alert(this.courseLessonDetail.msg, '提示', {
          showCancelButton:true,
          confirmButtonText: '登录',
          cancelButtonText:'继续试看',
          callback: action => {
            if(action == 'confirm'){
              this.$router.push('Login');
            }
          }
        });

        this.courseLessonDetail = this.courseLessonDetail.data;
        this.reallyPlayVideo(this.courseLessonDetail.m3u8_file_url);
      
     } if (this.courseLessonDetail.code === 400104){
        this.$alert(this.courseLessonDetail.msg, '提示', {
          confirmButtonText: '确定',
          // callback: action => {
            
          // }
        });

        this.courseLessonDetail = this.courseLessonDetail.data;
        this.reallyPlayVideo(this.courseLessonDetail.m3u8_file_url);
    }else{
      this.reallyPlayVideo(this.courseLessonDetail.m3u8_file_url);
    }

     
   },

   async fetch_learningCourseLesson(){

     let sendobj = {
        play_time_stamp:Math.floor(this.myVideo.currentTime())
      };
      if(this.courseLessonDetail.id){
        sendobj.course_lesson_id = this.courseLessonDetail.id;
      }

     await this.$fly.get('/userCourse/learningCourseLesson',sendobj);
   },

  initVideo() {
    //初始化视频方法
    this.myVideo = this.$videojs("myVideo", {
        autoplay:false,
        controls:true,
        preload:'auto',
        language: 'zh',
        bigPlayButton: true,
        // textTrackDisplay: false,
        // posterImage: true,
        errorDisplay: false,
        hls: { withCredentials: true }
    });

    //视频源数据加载完成
    this.myVideo.on('loadedmetadata', () => {
      //设置上次播放时间lastLearnTime(秒)
      this.myVideo.currentTime(this.courseLessonDetail.course_lesson_last_view_timestamp);
    });
    //视频播放
    this.myVideo.on('play',  () => {
      //当前播放时长(秒)
      // let currentTime = Math.floor(this.myVideo.currentTime());
      // console.log("视频播放:",currentTime);

      this.timer = setInterval(()=>{
        this.fetch_learningCourseLesson();
      },1000*5);
      this.fetch_learningCourseLesson();
    });
    //视频暂停
    this.myVideo.on('pause', () => {
      //当前播放时长(秒)
      // let currentTime = Math.floor(this.myVideo.currentTime());
      // console.log("视频暂停:", currentTime);

      clearInterval(this.timer)
      this.fetch_learningCourseLesson();
    });
    //视频播放完毕
    this.myVideo.on('ended', ()=> {
      //当前播放时长(秒)
      // let currentTime = Math.floor(this.myVideo.currentTime());
      // console.log('视频播放完毕!', currentTime);

      this.fetch_learningCourseLesson();
    });


    //播放进度
    // this.myVideo.on('timeupdate', () => {
    //   //当前播放时长(秒)
    //   var currentTime = Math.floor(this.myVideo.currentTime());
    //   console.log("播放进度:",currentTime);

    //   // if (currentTime > 0 && currentTime > totalTime && (currentTime % 5 == 0)) {
    //   //   //每隔5秒，向服务器提交播放时间(秒)
    //   // }
    //   // totalTime = currentTime;
    // });
    

  },
  reallyPlayVideo(m3u8_file_url){
    console.log("准备视频：", m3u8_file_url);

    this.myVideo.src({
      src:m3u8_file_url,
      type: 'application/x-mpegURL',
    });

  },
  onLook(course_id, course_lesson_id){
    // this.$router.push({ name: 'Look', params: { id: course_id, course_lesson_id:course_lesson_id }})
    this.$route.params.course_lesson_id = course_lesson_id;
    console.log("this.$route.params:",this.$route.params);

    this.fetch();
  },
   onGoHome(){
     this.$router.push('/')
   }
  },
  beforeDestroy(){
    clearInterval(this.timer)
  },
  destroyed () {
    // console.log("销毁myVideo");
    this.myVideo.dispose()
  }
}
</script>

<style lang='scss'>

.look{

  .viewbox{
    width:1024px;
    margin: 0 auto;
    background-color: #7A7A7A;

    .viewinfo{
      width: 100%;
      height: 536px;
      overflow: hidden;
      display: flex;
      
      .view{
        width: 70%;
        height: 100%;
      }

      .lesson_list{
         width: 30%;
          overflow: auto;

          .item:last-child{
            margin-bottom: 10px;
          }

         .item{
            width:94%;
            height:146px;
            background-color:#fff;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
            padding:10px 0;
            border-radius: 5px;
            text-align: left;
            margin-left: 9px;
            margin-top: 10px;

            .tit_name{
              display:flex;
              align-items:center;

              .f1{
                width:25%;
                height:35px;
                line-height:35px;
                background-color:#00B3A4;
                color:#fff;
                font-size:16px;
                overflow:hidden;
                padding: 0 6px;
                font-weight: bold;
              }

              .f2{
                width:60%;
                height:35px;
                line-height:35px;
                color:#000;
                font-size:16px;
                overflow:hidden;
                margin-left:6px;
              }

            }

            .tit_info{
              display:flex;
              align-items:center;

              .imgbox{
                width:158px;
                height:106px;
                margin-top: 6px;
                margin-left: 6px;
                cursor: pointer;

                img{
                  width:158px;
                  height:106px;
                }
              }

              .info{
                font-size:12px;
                color: #808080;
                margin-left:8px;
                width:130px;

                .l{
                  display:flex;
                  align-items:center;
                  margin: 6px 0;

                  i{
                    color:#00B3A4;
                    margin-right:8px;
                  }

                  span{
                    margin-left:8px;
                  }
                }
                
              }
            }
          }


      }

    }

    .v_name{
      width: 100%;
      height: 60px;
      line-height:60px;
      color: #fff;
      font-size: 26px;
      margin: 0 20px;
    }

  }

  .course_desc{
    width:1024px;
    margin: 40px auto;
    display: flex;
    justify-content:space-between;

    .desc{
      width: 60%;

      .tit{
        font-size: 20px;
        color: #585959;
        border-bottom: 1px solid #979797;
        padding-bottom: 10px;
      }

      .con{
        font-size: 14px;
        color: #585959;
        line-height: 25px;
        margin-top: 20px;
      }
      
    }

    .goindex{
      width: 330px;

      img{
        display: block;
        width: 100%;
        height: 184px;
        border-radius: 10px;
      }

      .el-button{
        display: block;
        width: 100%;
        height: 50px;
        margin-top: 20px;
        font-size: 22px
      }
    }

  }

  .free{
    background: #D8D8D8;
    border: 1px solid #979797;

    .free_course_box{
      width:1024px;
      margin: 60px auto 0;
    
      .tit{
        background-color:#fff;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
        padding:10px 14px;
        border-radius: 5px;
        display:flex;
        align-items:baseline;

        .t1{
          font-size: 20px;
          color: #00B3A4;
        }

        .t2{
          font-size: 16px;
          color: #B3B3B3;
          margin-left:20px;
        }
      }

      .el-carousel{
        margin-top:20px;
      }

      .el-carousel__arrow{
        display: none;
      }

      .el-carousel__button{
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #CCC;
      }

      .is-active button {
        background-color: #999;
        width: 40px;
        
      }
    }

    .item:nth-child(3n) {
      margin-right: 0;
    }

    .item{
      width:306px;
      height:146px;
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 0;
      border-radius: 5px;
      text-align: left;
      margin-right: 52px;
      display: inline-block;
      margin-bottom: 20px;

      .tit_name{
        display:flex;
        align-items:center;

        .f1{
          width:25%;
          height:35px;
          line-height:35px;
          background-color:#00B3A4;
          color:#fff;
          font-size:16px;
          overflow:hidden;
          padding: 0 6px;
          font-weight: bold;
        }

        .f2{
          width:60%;
          height:35px;
          line-height:35px;
          color:#000;
          font-size:16px;
          overflow:hidden;
          margin-left:6px;
        }

      }

      .tit_info{
        display:flex;
        align-items:center;

        .imgbox{
          width:158px;
          height:106px;
          margin-top: 6px;
          margin-left: 6px;
          cursor: pointer;
          position: relative;

          img{
            width:158px;
            height:106px;
          }

          .playBtn{ 
            position: absolute; 
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            height: 50px; 
            width:50px; 
            -webkit-border-radius: 100%; 
            -moz-border-radius: 100%; 
            -o-border-radius: 100%; 
            border-radius: 100%; 
            margin: auto; 
            background-color: rgba(115, 133, 159, 0.5);
            border: 2px solid #fff; 

            a { 
              border-color: transparent transparent transparent #fff; 
              border-width: 8px 0 8px 12px;  
              width: 0; height: 0; 
              border-style: solid;
              text-indent: -9999px; 
              position: absolute; 
              top: 16px;
              left: 21px; 
            }
          }
        }

        .info{
          font-size:12px;
          color: #808080;
          margin-left:8px;
          width:130px;

          .l{
            display:flex;
            align-items:center;
            margin: 6px 0;

            i{
              color:#00B3A4;
              margin-right:8px;
            }

            span{
              margin-left:8px;
            }
          }
          
        }
      }
    }


    .banner_box{
      margin: 0 auto 0;

      .box{
        width:1024px;
        margin: 0 auto;
        display:flex;
        justify-content:space-between;
        flex-wrap: wrap;
        padding: 20px 0;

        a{
          font-size: 24px;

          img{
            width:330px;
            height:184px;
            border-radius:10px;
          }
        }
      
      }
    }
    
  }

  .video-js .vjs-big-play-button{
    font-size: 2.5em;
    line-height: 2.3em;
    height: 2.5em;
    width: 2.5em;
    -webkit-border-radius: 2.5em;
    -moz-border-radius: 2.5em;
    border-radius: 2.5em;
    background-color: #73859f;
    background-color: rgba(115,133,159,.5);
    border-width: 0.15em;
    margin-top: -1.25em;
    margin-left: -1.75em;
  }
  /* 中间的播放箭头 */
  .vjs-big-play-button .vjs-icon-placeholder {
      font-size: 1.63em;
  }

  /*暂停时显示播放按钮 */
  .vjs-paused .vjs-big-play-button,
  .vjs-paused.vjs-has-started .vjs-big-play-button {
      display: block;
  }
    
}

</style>